import { Link } from "react-router-dom";
import { ArrowUpRight, MountainSnow, Flower, Sparkles, Church, Plane, Camera } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const EXPERIENCES = [
  { icon: MountainSnow, title: "Char Dham Yatra", note: "Kedarnath · Badrinath · Yamunotri · Gangotri — curated multi-day pilgrimage packages.", to: "/yatra", cta: "Plan Your Yatra" },
  { icon: Church,       title: "Triyuginarayan Weddings", note: "Renew or take vows at the sacred temple where Shiva & Parvati were married.", to: "/weddings", cta: "Explore Weddings" },
  { icon: Sparkles,     title: "Anniversary Celebrations", note: "Signature 4-day Divine Anniversary Journey · silver, golden, diamond milestones.", to: "/book/anniversary", cta: "Explore Anniversaries" },
  { icon: Flower,       title: "Corporate & Cultural Events", note: "Retreats, off-sites, brand launches, 31st Celebration & New Year Blessings.", to: "/events", cta: "Explore Events" },
  { icon: Plane,        title: "Helicopter & Aerial", note: "Kedarnath shuttle, full Char Dham circuit, and private charter arrangements.", to: "/book/transport", cta: "Enquire Helicopter" },
  { icon: Camera,       title: "Photography & Studios", note: "Couple, family, and heritage shoots against the Himalayan skyline.", to: "/gallery", cta: "View Gallery" },
];

export default function Experiences() {
  return (
    <main className="bg-kc min-h-screen">
      <section className="relative pt-32 md:pt-40 pb-14 md:pb-20 bg-black-lux text-[#F8F6F2] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?auto=format&fit=crop&w=2000&q=80"
          alt="" className="absolute inset-0 w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(11,11,12,0.7), rgba(11,11,12,0.95))" }} />
        <div className="relative max-w-[1500px] mx-auto px-6 md:px-12">
          <div className="overline text-gold">Experiences · Curated by THE KC INDIA</div>
          <h1 className="font-serif-display text-4xl md:text-6xl lg:text-7xl mt-6 font-light leading-[1.02] tracking-[-0.02em] max-w-4xl">
            Every Himalayan story, <br /><span className="italic text-gold">curated for you.</span>
          </h1>
          <p className="mt-6 text-[15px] md:text-[16px] leading-[1.8] text-[#F8F6F2]/75 max-w-2xl">
            From the sacred pheras at Triyuginarayan to the helicopter shuttle to Kedarnath — every experience under THE KC INDIA is held with the same reverence.
          </p>
        </div>
      </section>

      <section className="max-w-[1500px] mx-auto px-6 md:px-12 py-16 md:py-24" data-testid="experiences-grid">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {EXPERIENCES.map((e, i) => (
            <Reveal key={i} delay={i * 60}>
              <div className="group bg-surface border border-kc h-full flex flex-col p-7 md:p-8 hover:border-gold/50 transition-all" data-testid={`experience-card-${i}`}>
                <div className="w-11 h-11 border border-gold/40 flex items-center justify-center text-gold"><e.icon size={17} strokeWidth={1.4} /></div>
                <div className="mt-6 text-[10px] uppercase tracking-[0.28em] text-gold">№ {String(i + 1).padStart(2, "0")}</div>
                <div className="font-serif-display text-2xl md:text-[26px] mt-3 leading-tight">{e.title}</div>
                <p className="mt-4 text-[13.5px] text-ink-soft leading-[1.7] flex-1">{e.note}</p>
                <Link to={e.to} className="mt-6 pt-5 border-t border-kc inline-flex items-center justify-between text-[10px] uppercase tracking-[0.28em] text-gold hover:text-ink transition-colors" data-testid={`experience-cta-${i}`}>
                  {e.cta} <ArrowUpRight size={12} />
                </Link>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
